import axios from "axios";
import { useState } from "react";
import { mobile } from "../data/categories";
import { Category } from "../models/projectModel";
import Spinner from "./Spinner";

interface Props {
  category: Category;
  imagePath: string;
  isThumbnail?: boolean;
  isCover?: boolean;
  isRowCover?: boolean;
  alt: string;
  index: number;
}

export const ScaledImage = ({
  category,
  imagePath,
  isThumbnail = false,
  isCover = false,
  isRowCover = false,
  index,
  alt,
}: Props) => {
  const [isLoading, setisLoading] = useState(true);

  const tumbnailScale =
    category.key === mobile.key ? "w_62,h_100,c_scale" : "w_100,h_62,c_scale";

  const scaleRule =
    category.key === mobile.key ? "c_fill,g_center,h_600,w_338" : "c_fill,g_center,h_338,w_600";

  const coverRule = "c_fill,g_center,h_600,w_338";
  const rowCoverRule = "c_fill,g_center,h_200,w_130";

  var imageSplitted = imagePath.split("/upload/");
  imageSplitted[0] = imageSplitted[0] + "/upload";

  var scaledPath = isThumbnail
    ? `${imageSplitted[0]}/${tumbnailScale}/${imageSplitted[1]}`
    : isCover
    ? `${imageSplitted[0]}/${coverRule}/${imageSplitted[1]}`
    : isRowCover
    ? `${imageSplitted[0]}/${rowCoverRule}/${imageSplitted[1]}`
    : `${imageSplitted[0]}/${scaleRule}/${imageSplitted[1]}`;

  async function fetchImage() {
    await axios.get(scaledPath);
    setisLoading(false);
  }

  fetchImage();

  return isLoading ? (
    <Spinner />
  ) : (
    <div className="flex justify-center w-full">
      <img src={scaledPath} alt={`${alt}_${index}`} width={"100%"} />
    </div>
  );
};
